import { render, staticRenderFns } from "./WarehouseInbound.vue?vue&type=template&id=5c8a103e&scoped=true"
import script from "./WarehouseInbound.vue?vue&type=script&lang=js"
export * from "./WarehouseInbound.vue?vue&type=script&lang=js"
import style0 from "./WarehouseInbound.vue?vue&type=style&index=0&id=5c8a103e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a103e",
  null
  
)

export default component.exports